/* eslint-disable */

import { APIClient } from "./_api";
const endpoint = "/ContainerPricing";
const endpointContainer = "/Container";

export function getAll(query) {
  return APIClient.post(`${endpoint}/filter`, query);
}

export function getAllType(query) {
  return APIClient.get(`${endpointContainer}/type`, query);
}

export function getAllSize(query) {
  return APIClient.get(`${endpointContainer}/size`, query);
}
export function getAllContainer() {
  return APIClient.get(`${endpointContainer}`);
}

export function editContainer(values) {
  return APIClient.put(`${endpointContainer}/${values.id}`, values.values);
}

export function getOne() {
  return APIClient.get(`${endpoint}`);
}

export function remove(id) {
  return APIClient.delete(`${endpoint}/${id}`);
}

export function create(values) {
  return APIClient.post(`${endpoint}`, values);
}

export function active(value) {
  return APIClient.put(`${endpoint}/${value.id}`, { isActive: value.isActive });
}
